import { api } from './baseApi';
export var profileModerationApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getProfileModerationEnabled: builder.query({
                query: function () {
                    return ({
                        url: '/profile-moderation/enabled',
                        method: 'GET',
                    });
                },
            }),
            getProfileModerationRequests: builder.query({
                query: function (params) {
                    var status = params && 'status' in params ? params.status : undefined;
                    return {
                        url: '/profile-moderation',
                        method: 'GET',
                        params: status ? { status: status } : undefined,
                    };
                },
                providesTags: ['ProfileModeration'],
            }),
            getProfileModerationPendingCount: builder.query({
                query: function () {
                    return ({
                        url: '/profile-moderation/pending-count',
                        method: 'GET',
                    });
                },
                providesTags: ['ProfileModeration'],
            }),
            approveProfileModeration: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/profile-moderation/".concat(id, "/approve"),
                        method: 'POST',
                    });
                },
                invalidatesTags: ['ProfileModeration'],
            }),
            rejectProfileModeration: builder.mutation({
                query: function (_a) {
                    var id = _a.id, reason = _a.reason;
                    return ({
                        url: "/profile-moderation/".concat(id, "/reject"),
                        method: 'POST',
                        body: { reason: reason },
                    });
                },
                invalidatesTags: ['ProfileModeration'],
            }),
            deleteProfileModeration: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/profile-moderation/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['ProfileModeration'],
            }),
        });
    },
});
export var useGetProfileModerationEnabledQuery = profileModerationApi.useGetProfileModerationEnabledQuery, useGetProfileModerationRequestsQuery = profileModerationApi.useGetProfileModerationRequestsQuery, useGetProfileModerationPendingCountQuery = profileModerationApi.useGetProfileModerationPendingCountQuery, useApproveProfileModerationMutation = profileModerationApi.useApproveProfileModerationMutation, useRejectProfileModerationMutation = profileModerationApi.useRejectProfileModerationMutation, useDeleteProfileModerationMutation = profileModerationApi.useDeleteProfileModerationMutation;
